import { makeStyles } from "@fluentui/react-components";

export const useHeaderStyles = makeStyles({
  toolbar: {
    display: "flex",
    backgroundColor: "#0a2e4a",
  },
  toolbar_icon_container: {
    display: "flex",
    float: "right",
    color: "#f7f8fa",
    right: "20px",
    top: "9px",
    position: "absolute",
  },
  icon24: { fontSize: "24px", cursor: "pointer" },
  icon25: { fontSize: "24px", cursor: "none",color: "grey"  },
  subheader_container: {
    display: "flex",
    verticalAlign: "center",
    flexDirection: "row",
    alignItems: "flex-end",
    color: "#f7f8fa",
    height: "36px",
    
  },
  textcenter: {
    textAlign: "center",
  },
  subheader_item_container: {
    display: "flex",
    verticalAlign: "center",
    flexDirection: "column",
    justifyContent: "center",
    color: "#f7f8fa",
    right: "30px",
    width: "80%",
    position: "absolute",
  },
});
